import WsProvider from './provider/WSProvider'
var base64 = require('base64_js');
var serviceName = "islem";
var seoService = {
    islemListesi(baslangic, limit) {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                baslangic: 0,
                limit: 10,
                methodName: "islemListesi"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    }
}

export default seoService

